/** Iter 632 — customer wizard · pending-review 409 prompt (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import { Loader2, Star, RefreshCw } from "lucide-react";

export default function PendingReviewPrompt({ w, brandColor, textOnBrand }) {
  const { pending409, startSession, creating } = w;
  return (
    <div className="rounded-2xl bg-slate-50 border border-slate-200 p-5" data-testid="engage-pending-review-prompt">
      <div className="flex items-start gap-3">
        <Star className="w-5 h-5 text-amber-500 shrink-0 mt-0.5" />
        <div>
          <div className="font-bold text-slate-900 text-sm">Finish your earlier review?</div>
          <p className="mt-1 text-xs text-slate-500 leading-relaxed">
            {pending409.message || "You still have a review pending from a previous visit."}
          </p>
        </div>
      </div>
      <button
        type="button"
        data-testid="engage-pending-ack"
        onClick={() => startSession(true)}
        disabled={creating}
        style={{ backgroundColor: brandColor, color: textOnBrand }}
        className="mt-4 w-full inline-flex items-center justify-center gap-2 rounded-full font-bold py-3 text-sm shadow-card disabled:opacity-60"
      >
        {creating ? <Loader2 className="w-4 h-4 animate-spin" /> : <RefreshCw className="w-4 h-4" />}
        Continue with a new session
      </button>
    </div>
  );
}
